import React from 'react';
import styles from './SecuritySection.module.css';
import {
  VerifiedUserOutlined,
  LockOutlined,
  BackupOutlined,
  ManageAccountsOutlined,
  GavelOutlined,
  CloudOutlined,
} from '@mui/icons-material';

const securityItems = [
  { Icon: LockOutlined, title: 'Conexão segura', description: 'Dados protegidos em trânsito com HTTPS e backups diários fora do servidor.', bgColor: '#dbeafe', color: '#2563eb' },
  { Icon: BackupOutlined, title: 'Backup automático', description: 'Cópias de segurança com redundância.', bgColor: '#dcfce7', color: '#16a34a' },
  { Icon: ManageAccountsOutlined, title: 'Permissões por usuário', description: 'Cada pessoa acessa apenas o necessário.', bgColor: '#ede9fe', color: '#7c3aed' },
  { Icon: GavelOutlined, title: 'LGPD', description: 'Política de privacidade, exportação dos dados da clínica e canal para solicitações de titulares.', bgColor: '#fce7f3', color: '#db2777' },
  { Icon: CloudOutlined, title: 'Nuvem segura', description: 'Alta disponibilidade para o seu dia a dia.', bgColor: '#ffedd5', color: '#ea580c' },
];

function SecuritySection() {
  return (
    <section id="seguranca" className={styles.securitySection}>
      <div className={styles.sectionContainer}>

        {/* Badge LGPD */}
        <div className={styles.lgpdBadge}>
          <VerifiedUserOutlined className={styles.lgpdBadgeIcon} />
          <span>Privacidade e LGPD</span>
        </div>

        <h2 className={styles.sectionTitle}>
          Segurança para você, sua equipe e seus pacientes
        </h2>
        <p className={styles.sectionSubtitle}>
          Dados protegidos, backups automáticos e controle de acesso para você trabalhar com tranquilidade.
        </p>

        <div className={styles.securityGrid}>
          {securityItems.map((item) => (
            <div className={styles.securityCard} key={item.title}>
              <div className={styles.cardIconWrapper} style={{ backgroundColor: item.bgColor }}>
                <item.Icon style={{ fontSize: '1.4rem', color: item.color }} />
              </div>
              <div className={styles.cardText}>
                <span className={styles.cardTitle}>{item.title}</span>
                <span className={styles.cardDescription}>{item.description}</span>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default SecuritySection;
